import { cloneDeep } from 'lodash';

const getFtdRestrictions = async ({ state, effects }) => {
  let paymentMethods = cloneDeep(state.paymentMethods);

  paymentMethods.ftdRestrictions.isBusy = true;
  state.paymentMethods = paymentMethods;

  const { result } = await effects.paymentMethods.getFtdRestrictions();

  paymentMethods = cloneDeep(state.paymentMethods);
  if (result) {
    paymentMethods.ftdRestrictions.initialRestrictions = result;
    paymentMethods.ftdRestrictions.changedRestrictions = result;
  }

  paymentMethods.ftdRestrictions.isBusy = false;
  state.paymentMethods = paymentMethods;
};

const saveFtdRestrictions = async ({ state, effects }, data) => {
  let paymentMethods = cloneDeep(state.paymentMethods);

  paymentMethods.ftdRestrictions.isBusy = true;
  state.paymentMethods = paymentMethods;

  const result = await effects.paymentMethods.setFtdRestrictions(data);

  if (result) {
    paymentMethods.ftdRestrictions.initialRestrictions = data;
  }

  paymentMethods = cloneDeep(state.paymentMethods);

  paymentMethods.ftdRestrictions.isBusy = false;
  state.paymentMethods = paymentMethods;
};

const editFtdRestrictions = async ({ state }, data) => {
  state.paymentMethods.ftdRestrictions.changedRestrictions = data;
};

const getWithdrawalLimits = async ({ state, effects }) => {
  let paymentMethods = cloneDeep(state.paymentMethods);

  paymentMethods.withdrawalLimits.isBusy = true;
  state.paymentMethods = paymentMethods;

  const { result } = await effects.paymentMethods.getWithdrawalLimits();

  paymentMethods = cloneDeep(state.paymentMethods);
  if (result) {
    paymentMethods.withdrawalLimits.initialLimits = result;
  }

  paymentMethods.withdrawalLimits.isBusy = false;
  state.paymentMethods = paymentMethods;
};

const saveWithdrawalLimits = async ({ state, effects }, data) => {
  let paymentMethods = cloneDeep(state.paymentMethods);

  paymentMethods.withdrawalLimits.isBusy = true;
  state.paymentMethods = paymentMethods;

  const numberCastedData = {
    min: data.min === null ? null : Number(data.min),
    max: data.max === null ? null : Number(data.max),
  };

  const result = await effects.paymentMethods.setWithdrawalLimits(numberCastedData);

  if (result) {
    paymentMethods.withdrawalLimits.initialLimits = data;
  }

  paymentMethods = cloneDeep(state.paymentMethods);

  paymentMethods.withdrawalLimits.isBusy = false;
  state.paymentMethods = paymentMethods;
};

export default {
  getFtdRestrictions,
  saveFtdRestrictions,
  editFtdRestrictions,
  getWithdrawalLimits,
  saveWithdrawalLimits,
};
